import React, { useState, useEffect } from "react";
import { formatCurrency } from '../../../_helpers';

const Personal = props => {

    const state = props.state;

    //let v = props.nacionalidades.find(e => e.codigo === 'NAC_CL');
    const [idChile,setIdChile] = useState(3)//chile por defecto

    /*const esExtranjero = ()=>{
        try{
            if(!state.nacionalidad) return false
            let v = props.nacionalidades.find(e => parseInt(e.id) === parseInt(state.nacionalidad));
            console.log(v)
            if(!v) return false
            else
                return v.codigo!=='NAC_CL'
        }catch(e){
            return false
        }

    }*/

    return (
        <>
        <h5 className="mb-3 text-secondary">Información Personal</h5>
        <div>
            <div className="row">
                <div className="col-4 col-md-4">
                    <div className="mb-3">
                        <label htmlFor="rut" className="form-label">Rut:</label>
                        <input maxLength={10} type="text" className="form-control" id="rut" name="rut" value={formatCurrency(state.rut)} onChange={e => props.handleOnChangeNum(e)} placeholder={(!state.rut && props.error.rut) ? props.error.rut : undefined} style={props.error.rut ? { borderColor: 'rgba(220,53,69,0.5)', backgroundColor: 'rgba(220,53,69,0.06)' } : undefined}/>

                    </div>
                </div>
                <div className="col-2 col-md-2">
                    <div className="mb-3">
                        <label htmlFor="dv" className="form-label">DV:</label>
                        <input type="text" className="form-control" id="dv" name="dv" value={state.dv} disabled/>
                    </div>
                </div>
                <div className="col-6 col-md-6">
                    <div className="mb-3">
                        <label htmlFor="fecha-nacimiento" className="form-label">Fecha de Nacimiento:</label>
                        <input type="date" className="form-control" id="fechanac" name="fechanac" value={state.fechanac} onChange={e => props.handleOnChangeText(e)} style={props.error.fechanac ? { borderColor: 'rgba(220,53,69,0.5)', backgroundColor: 'rgba(220,53,69,0.06)' } : undefined} />

                    </div>
                </div>

                <div className="col-md-12">
                    <div className="mb-3">
                        <label htmlFor="nombres" className="form-label">Nombres:</label>
                        <input type="text" className="form-control" id="nombres" name="nombres" value={state.nombres} onChange={e => props.handleOnChangeText(e)} placeholder={(!state.nombres && props.error.nombres) ? props.error.nombres : undefined} style={props.error.nombres ? { borderColor: 'rgba(220,53,69,0.5)', backgroundColor: 'rgba(220,53,69,0.06)' } : undefined}/>

                    </div>
                </div>

                <div className="col-6 col-md-6">
                    <div className="mb-3">
                        <label htmlFor="primer-apellido" className="form-label">Primer Apellido:</label>
                        <input type="text" className="form-control" id="primerapellido" name="primerapellido" value={state.primerapellido} onChange={e => props.handleOnChangeText(e)} placeholder={(!state.primerapellido && props.error.primerapellido) ? props.error.primerapellido : undefined} style={props.error.primerapellido ? { borderColor: 'rgba(220,53,69,0.5)', backgroundColor: 'rgba(220,53,69,0.06)' } : undefined}/>

                    </div>
                </div>

                <div className="col-6 col-md-6">
                    <div className="mb-3">
                        <label htmlFor="segundo-apellido" className="form-label">Segundo Apellido:</label>
                        <input type="text" className="form-control" id="segundoapellido" name="segundoapellido" value={state.segundoapellido} onChange={e => props.handleOnChangeText(e)} placeholder={(!state.segundoapellido && props.error.segundoapellido) ? props.error.segundoapellido : undefined} style={props.error.segundoapellido ? { borderColor: 'rgba(220,53,69,0.5)', backgroundColor: 'rgba(220,53,69,0.06)' } : undefined}/>

                    </div>
                </div>

                <div className="col-6 col-md-6">
                    <div className="mb-3">
                        <label htmlFor="genero" className="form-label">Género:</label>
                        <select className="form-select" id="genero" name="genero" value={state.genero} onChange={e => props.handleOnChangeText(e)} style={props.error.genero ? { borderColor: 'rgba(220,53,69,0.5)', backgroundColor: 'rgba(220,53,69,0.06)' } : undefined}>
                            <option value="">Seleccione</option>
                            {
                                props.generos?.map((row,index) => {
                                    return(
                                        <option key={index} value={row.id}>{row.descripcion}</option>
                                    );
                                })
                            }
                        </select>

                    </div>
                </div>

                <div className="col-6 col-md-6">
                    <div className="mb-3">
                        <label htmlFor="nacionalidad" className="form-label">Nacionalidad:</label>
                        <select className="form-select" id="nacionalidad" name="nacionalidad" value={state.nacionalidad}
                        onChange={e => props.handleOnChangeText(e)} style={props.error.nacionalidad ? { borderColor: 'rgba(220,53,69,0.5)', backgroundColor: 'rgba(220,53,69,0.06)' } : undefined}>
                            <option value="">Seleccione</option>
                            {
                                props.nacionalidades?.map((row,index) => {
                                    return(
                                        <option key={index} value={row.id}>{row.descripcion}</option>
                                    );
                                })
                            }
                        </select>

                    </div>
                </div>

                <div className="col-6 col-md-6">
                    <div className="mb-3">
                        <label htmlFor="region_residencia" className="form-label">Región de Residencia:</label>
                        <select className="form-select" id="region_residencia" name="region_residencia" value={state.region_residencia} onChange={e => props.handleOnChangeText(e)} style={props.error.region_residencia ? { borderColor: 'rgba(220,53,69,0.5)', backgroundColor: 'rgba(220,53,69,0.06)' } : undefined}>
                            <option value="">Seleccione</option>
                            {
                                props.regiones?.map((row,index) => {
                                    return(
                                        <option key={index} value={row.id}>{row.name}</option>
                                    );
                                })
                            }
                        </select>

                    </div>
                </div>


                <div className="col-6 col-md-6">
                    <div className="mb-3">
                        <label htmlFor="comuna_residencia" className="form-label">Comuna de Residencia:</label>
                        <select className="form-select" id="comuna_residencia" name="comuna_residencia" value={state.comuna_residencia} onChange={e => props.handleOnChangeText(e)} style={props.error.comuna_residencia ? { borderColor: 'rgba(220,53,69,0.5)', backgroundColor: 'rgba(220,53,69,0.06)' } : undefined}>
                            <option value="">Seleccione</option>
                            {
                                props.comuna_residencia?.map((row,index) => {
                                    return(
                                        <option key={index} value={row.id}>{row.name}</option>
                                    );
                                })
                            }
                        </select>

                    </div>
                </div>


                {
                (!!state.nacionalidad && Number(idChile)!==Number(state.nacionalidad))?
                <div className="col-md-12">
                    <div className="mb-3">
                        <label htmlFor="residencia" className="form-label">Tipo de Residencia:</label>
                        <select className="form-select" id="residencia" name="residencia" value={state.residencia} onChange={e => props.handleOnChangeText(e)} style={props.error.residencia ? { borderColor: 'rgba(220,53,69,0.5)', backgroundColor: 'rgba(220,53,69,0.06)' } : undefined}>
                            <option value="">Seleccione</option>
                            {
                                props.tipo_residencia.map((row,index) => {
                                    return(
                                        <option key={index} value={row.id}>{row.descripcion}</option>
                                    );
                                })
                            }
                            </select>

                    </div>
                </div> : <></>
                }



            </div>
        </div>
        </>
    );
  }

export default Personal;
